// extracted by mini-css-extract-plugin
export default {"container":"SignatureTextByState_container__RTcH+"};